import { render, staticRenderFns } from "./CitasProximas.vue?vue&type=template&id=78a3114b&"
import script from "./CitasProximas.vue?vue&type=script&lang=js&"
export * from "./CitasProximas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports